export default class Store {
  constructor(code, name, checked) {
    this.code = code;
    this.name = name;
    this.checked = checked;
  }
}